import { Avatar } from '../../components/Avatar'
import { userName, type UserMap } from '../../lib/channels'

export function SeenBy({ userIds, users }: { userIds: string[]; users: UserMap }) {
  const names = userIds.map((id) => userName(users, id))
  const label = names.length <= 2 ? names.join(' and ') : `${names.slice(0, 2).join(', ')} and ${names.length - 2} more`
  return (
    <div className="seen-by" aria-label={`Seen by ${names.join(', ')}`} title={`Seen by ${names.join(', ')}`}>
      {userIds.slice(0, 5).map((id) => (
        <Avatar key={id} user={users.get(id)} id={id} />
      ))}
      <span>Seen by {label}</span>
    </div>
  )
}
